import { getIsLogin } from '@/utils/cookie';
import { useEffect, useState } from 'react';
import { useLang } from './useLang';
import gtm from '@/utils/gtm';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { isMembersFestival } from '@/utils/membersFestival';
import './index.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';
import LoginFormModal from '@/components/LoginFormModal';
import { createPortal } from 'react-dom';

// 没有登录
export default function HeaderUserTipsWin({ closeCallback, className }: { closeCallback?: any; className?: string }) {
    const [isLogin, setIsLogin] = useState(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        if (isLogin2) {
            setIsLogin(true);
        }
    }, []);

    const { locale = 'us' } = useRouter();
    const { t } = useLang();
    const [registerUrl, setRegisterUrl] = useState('');
    // const [registerUrl1, setRegisterUrl1] = useState('');
    const [loginUrl, setLoginUrl] = useState('');

    const mfStatus = isMembersFestival(locale);

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setRegisterUrl(`${window.location.origin}/${locale}/register?redirect=${encodeURIComponent(window.location.href)}`);
        // setRegisterUrl1(`${window.location.origin}/${locale}/register/passwordless?redirect=${encodeURIComponent(window.location.href)}`);
        setLoginUrl(`${window.location.origin}/${locale}/login?redirect=${encodeURIComponent(window.location.href)}`);
    }, []);
    const textButton = t('button');
    const textButton1 = t('button1');
    const textTips1 = t('register_tip');
    const textLogin = t('login');
    const closeHandle = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_close',
            button_name: 'Close',
            type: 'Authentication',
        });
        if (closeCallback) {
            closeCallback();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {!isLogin && (
                <div className={`HeaderV2-user-win-h5 ${className}`}>
                    {/* <HeaderUserTipsContent closeCallback={closeCallback} /> */}
                    <div className="HeaderV2-user-win-h5-l">
                        <div className="HeaderV2-UserTipsWin-line1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <rect width="16" height="16" fill="white" />
                                <path d="M2.66699 8.00001L6.00033 11.3333L13.3337 4.33334" stroke="#26AC04" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className="HeaderV2-UserTipsWin-line1-text">{mfStatus === 0 ? t('desc_1') : t('desc')}</span>
                        </div>
                        <div className="HeaderV2-UserTipsWin-line2">
                            {textTips1}
                            <EcoLink
                                className="HeaderV2-UserTipsWin-line2-link"
                                href={loginUrl}
                                onClick={() => signupCookie?.({ entry_name: 'top floating' })}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'signup_start',
                                    entry_type: 'fixed entry',
                                    entry_name: 'top floating',
                                    entry_position: 'none',
                                    source_channel: 'Website',
                                }}
                            >
                                {textLogin}
                            </EcoLink>
                        </div>
                    </div>
                    <div className="HeaderV2-user-win-h5-r">
                        <EcoLink
                            className="HeaderV2-UserTipsWin-line2"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'authentication_button',
                                type: 'Modal',
                                button_name: textButton1,
                                url: 'none',
                            }}
                            // href={registerUrl1}
                            onClick={(event) => {
                                event.stopPropagation();
                                signupCookie?.({
                                    entry_name: 'top floating_Password-free Register',
                                    page_url: window.location.href,
                                });
                                closeCallback && closeCallback();
                                setShowLoginModal(true);
                            }}
                        >
                            {textButton1}
                        </EcoLink>
                        <EcoLink
                            className="HeaderV2-UserTipsWin-line4"
                            href={registerUrl}
                            onClick={() => signupCookie?.({ entry_name: 'top floating' })}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'signup_start',
                                entry_type: 'fixed entry',
                                entry_name: 'top floating',
                                entry_position: 'none',
                                source_channel: 'Website',
                            }}
                        >
                            {textButton}
                        </EcoLink>
                    </div>
                </div>
            )}
            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </>
    );
}
